import React, { Fragment, useCallback } from 'react';
import classnames from 'classnames'

import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Button from '@material-ui/core/Button';
import GetAppIcon from '@material-ui/icons/GetApp';

import * as BookingByDateConstants from '../../../../constants/meeting/BookingByDateConstants';
import * as ApiConstants from '../../../../constants/ApiConstants';
import UseLoadingState from '../../../../control/loading/UseLoadingState';
import UseAlertMessageState from '../../../../control/alert/UseAlertMessageState';
import * as AlertMSGConstants from '../../../../constants/AlertMSGConstants';
import Loading from '../../../../control/loading/Loading';
import AlertMessage from '../../../../control/alert/AlertMessage';
import { fetchGet } from '../../../../utilities/ServiceUtils';

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
        // padding: '24px',
        paddingTop: 0
    },
    containerTable: {
        marginBottom: '35px'
    },
    titleSpan: {
        fontSize: 30
    },
    rootTitle: {
        padding: 5
    },
    rootData: {
        padding: 3,
        paddingLeft: '10px',
        paddingRight: '10px'
    },
    button: {
        height: '40px',
        marginBottom: '5px',
        padding: '0px',
        marginLeft: '10px',
        paddingRight: '10px',
        paddingLeft: '10px',
        backgroundColor: '#016f01 !important',
        color: '#FFFFFF'
    }
}));

const BookingByDateResultView = props => {
    const { result, onBtnClick } = props;
    const loadingState = UseLoadingState();
    const alertMessageState = UseAlertMessageState();
    
    const classes = useStyles();

    const handleDownload = useCallback(async (bookingId) => {
        try {
            loadingState.showLoading()
            const response = await fetchGet(`${ApiConstants.SERVICE_EXPORT_ATTENDEE_LIST.replace(":bookingId", bookingId)}`);

            const contentType = response.headers.get('Content-Type');
            if (!contentType || contentType.indexOf('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') === -1) {
                const errorJson = await response.json();
                const errors = errorJson.errors;
                if (Array.isArray(errors) && errors.length > 0) {
                    throw new Error(errors[0].detail)
                } else {
                    throw new Error(AlertMSGConstants.SYSTEM_ERROR)
                }
            }

            const blob = await response.blob();

            const disposition = response.headers.get('Content-Disposition');
            let filename = 'รายชื่อผู้ร่วมประชุม.xlsx';

            if (disposition && disposition.indexOf('filename=') !== -1) {
                const match = disposition.match(/filename\*?=(?:UTF-8'')?([^;]+)/i);
                if (match && match[1]) {
                    filename = decodeURIComponent(match[1].replace(/["']/g, ''));
                }
            }

            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            alertMessageState.showAlert({
                altMsg: error.message,
            });
        } finally {
            loadingState.hideLoading()
        }
    }, [])

    return (
        <Fragment>
            <Grid container className={classes.root}>
                <Grid item xs={12} container justify="center" >
                    {result.length === 0 ? <div>ไม่พบรายการ</div> :
                        result.map((item, index) => {
                            return (
                                <Grid container key={`listbooking-${index}-${item.building}`} className={classnames({ [classes.containerTable]: index + 1 !== result.length })}>
                                    <Grid container>
                                        <Grid item xs={12}>
                                            <span
                                                className={classes.titleSpan}
                                            >{`${item.bookingList[0].meaDistrictName} ${BookingByDateConstants.BUILDING} ${item.building} ${BookingByDateConstants.FLOOR} ${item.floor}`}</span>
                                            <Button
                                                variant="contained"
                                                className={classes.button}
                                                startIcon={<GetAppIcon />}
                                                onClick={() =>
                                                    onBtnClick({
                                                        building: item.building,
                                                        floor: item.floor
                                                    })
                                                }
                                            >
                                                ออกรายงาน Excel
                                        </Button>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Table
                                            className={classes.table}
                                            aria-label="simple table"
                                        >
                                            <TableHead>
                                                <TableRow>
                                                    {BookingByDateConstants.COLUMN.map(
                                                        (item, index2) => {
                                                            return (
                                                                <TableCell
                                                                    key={`COLUMN-${index}-${index2}`}
                                                                    align="center"
                                                                    style={{
                                                                        border:
                                                                            '1px solid grey',
                                                                        width:
                                                                            item.width,
                                                                        backgroundColor:
                                                                            '#b4c7a9'
                                                                    }}
                                                                    classes={{
                                                                        root:
                                                                            classes.rootTitle
                                                                    }}
                                                                >
                                                                    {item.title}
                                                                </TableCell>
                                                            );
                                                        }
                                                    )}
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {item.bookingList.map((row, index2) => (
                                                    <TableRow
                                                        key={`cell-${index}-${index2}`}
                                                        style={{
                                                            height:
                                                                '40px !important'
                                                        }}
                                                        classes={{
                                                            root: {
                                                                height:
                                                                    '40px !important'
                                                            }
                                                        }}
                                                    >
                                                        <TableCell
                                                            align="center"
                                                            classes={{
                                                                root:
                                                                    classes.rootData
                                                            }}
                                                            style={{
                                                                border:
                                                                    '1px solid #e0e0e0',
                                                                wordBreak:
                                                                    'break-all'
                                                            }}
                                                        >
                                                            {row.timeBooking}
                                                        </TableCell>
                                                        <TableCell
                                                            align="left"
                                                            classes={{
                                                                root:
                                                                    classes.rootData
                                                            }}
                                                            style={{
                                                                border:
                                                                    '1px solid #e0e0e0',
                                                                wordBreak:
                                                                    'break-all'
                                                            }}
                                                        >
                                                            {row.topic}
                                                        </TableCell>
                                                        <TableCell
                                                            align="center"
                                                            classes={{
                                                                root:
                                                                    classes.rootData
                                                            }}
                                                            style={{
                                                                border:
                                                                    '1px solid #e0e0e0',
                                                                wordBreak:
                                                                    'break-all'
                                                            }}
                                                        >
                                                            {row.numberOfAttendees}
                                                        </TableCell>
                                                        <TableCell
                                                            align="center"
                                                            classes={{
                                                                root:
                                                                    classes.rootData
                                                            }}
                                                            style={{
                                                                border:
                                                                    '1px solid #e0e0e0',
                                                                wordBreak:
                                                                    'break-all'
                                                            }}
                                                        >
                                                            {row.roomNameTH}
                                                        </TableCell>
                                                        <TableCell
                                                            align="center"
                                                            classes={{
                                                                root:
                                                                    classes.rootData
                                                            }}
                                                            style={{
                                                                border:
                                                                    '1px solid #e0e0e0',
                                                                wordBreak:
                                                                    'break-all'
                                                            }}
                                                        >
                                                            {row.chairman}
                                                        </TableCell>
                                                        <TableCell
                                                            align="center"
                                                            classes={{
                                                                root:
                                                                    classes.rootData
                                                            }}
                                                            style={{
                                                                border:
                                                                    '1px solid #e0e0e0',
                                                                wordBreak:
                                                                    'break-all'
                                                            }}
                                                        >
                                                            {row.empBooking}
                                                        </TableCell>
                                                        <TableCell
                                                            align="center"
                                                            classes={{
                                                                root:
                                                                    classes.rootData
                                                            }}
                                                            style={{
                                                                border:
                                                                    '1px solid #e0e0e0',
                                                                wordBreak:
                                                                    'break-all'
                                                            }}
                                                        >
                                                            {row.dateModify} เวลา{' '}
                                                            {row.timeModify}
                                                        </TableCell>
                                                        <TableCell
                                                            align="center"
                                                            classes={{
                                                                root:
                                                                    classes.rootData
                                                            }}
                                                            style={{
                                                                border:
                                                                    '1px solid #e0e0e0',
                                                                wordBreak:
                                                                    'break-all'
                                                            }}
                                                        >
                                                            <Button startIcon={<GetAppIcon />} variant='text' onClick={() => handleDownload(row.bookingId)}>
                                                                ดาวน์โหลด
                                                            </Button>
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </Grid>
                                </Grid>
                            );
                        })}
                </Grid>
            </Grid>
            <Loading isShowLoading={loadingState.isShowLoading} />
            <AlertMessage {...alertMessageState.altProps} />
        </Fragment>
    );
};

export default BookingByDateResultView;
